export default __webpack_public_path__ + "static/media/aloe_capital_logo_no_border.95a418a0.svg";